<template>
	<div id="app">
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive" />
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive" />
		<!-- <MouseTrailer /> -->
	</div>
</template>

<script>
import { mapActions } from 'vuex'
// import MouseTrailer from './components/MouseTrailer.vue'

export default {
	name: 'App',
	components: {
		// MouseTrailer
	},
	data(){
		return{
			userInfo:{}
		}
	},
	created(){
		// this.getUserInfo()
	},
	methods:{
		...mapActions(['GetInfo']),
		// 获取用户信息
		getUserInfo(){
			this.GetInfo().then(res => {
				this.userInfo = res.data
			})
		}
	}
}
</script>

<style lang="less">
	@import "../src/styles/font/font.css";
	@import "../src/styles/article.less";
	@import "../src/styles/vue-quill.snow.css";
	@import "../src/styles/iconfont/iconfont.css";
	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		line-height: 1.5;
	}

	#app {
		height: 100%;
		font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
		font-size: 18px;
		color: #292b2c;
	}
  .cu-po{
    cursor: pointer;
  }

  .sc_box{
    padding: 4px 10px;
    display: flex;
    align-items: center;
    border: 1px solid #D7D7D7;
    font-weight: 400;
    font-size: 14px;
    color: #858585;
    border-radius: 5px;
    cursor: pointer;
    img {
      width: 22px;
      height: 22px;
      margin-right: 5px;
    }
  }
  .sc_box_y{
    border: 1px solid #158E58;
    color: #158E58;
  }

	.xianIcon {
		width: 4px;
		height: 25px;
		background-color: #0db896;
		border-radius: 20%;
	}

	.txtHide {
		overflow: hidden;
		/*内容超出后隐藏*/
		text-overflow: ellipsis;
		/*超出内容显示为省略号*/
		white-space: nowrap;
		/*文本不进行换行*/
	}
	.txtHide2{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2; /* 控制显示的行数 */
		-webkit-box-orient: vertical;
	}

	/* flex布局 */
	.flex {
		display: flex;
	}

	.ju-cn {
		justify-content: center;
	}

	.ju-sb {
		justify-content: space-between;
	}

	.ju-sa {
		justify-content: space-around;
	}

	.ju-en {
		justify-content: flex-end;
	}

	.al-cn {
		align-items: center;
	}

	.al-en {
		align-items: flex-end;
	}
	.fd-top{
		flex-direction: column;
	}
	.fd-bom{
		flex-direction: column-reverse;
	}

	.fl-war {
		flex-wrap: wrap;
	}

	.flex1 {
		flex: 1;
	}
	.txt-cen{
		text-align: center;
	}

	.Warning {
		color: #E6A23C;
	}

	/* 滚动条整体样式 */
	::-webkit-scrollbar {
		width: 12px;
		background-color: #fff;
	}

	/* 滚动条轨道样式 */
	::-webkit-scrollbar-track {
		/* background-color: #F5F5F5; */
	}

	/* 滚动条滑块样式 */
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #e5e5e5;
	}

	.el-message-box{
		width: 340px !important;
		margin-right: 10px;
	}
</style>
